'use client';

import get from 'lodash/get';
import { type ReactNode, useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { cn } from '../../utils';

export function FormControl(props: {
  children: ReactNode;
  label: string;
  name: string;
  className?: string;
  subtitle?: string;
}) {
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const {
    formState: { errors },
  } = useFormContext();

  useEffect(() => {
    const error = get(errors, props.name);

    if (error?.message) {
      setErrorMessage(error.message.toString());
    } else {
      setErrorMessage('');
    }
  }, [errors, props.name]);

  return (
    <div className={cn('relative flex w-full flex-col', props.className)}>
      <FormLabel
        label={props.label}
        name={props.name}
        errorMessage={errorMessage}
      />
      {props.children}
      {!!props.subtitle && (
        <p className="mt-0.5 text-gray-400 text-xs">{props.subtitle}</p>
      )}
      <div className="absolute top-full">
        {!!errorMessage && (
          <p className={'mt-0.5 text-red text-xs'}>{errorMessage}</p>
        )}
      </div>
    </div>
  );
}

export function FormLabel(props: {
  label: string;
  name: string;
  errorMessage: string | null;
  className?: string;
}) {
  return (
    <label
      htmlFor={props.name}
      className={cn(
        'mb-0.5 block whitespace-nowrap font-medium text-sm transition-all',
        props.errorMessage?.length ? 'text-red' : 'text-gray-700',
        props.className
      )}
    >
      {props.label}
    </label>
  );
}
